import { Component, Input, Output, EventEmitter, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DroneReport } from 'src/app/core/data-models/drone-report.model';
import { DroneReportService } from "src/app/core/data-services/drone-report.service";
import { StatusBadgePipe } from "src/app/shared/pipes/status-badge.pipe";

@Component({
    selector: 'app-drone-report-item',
    standalone: true,
    imports: [CommonModule, StatusBadgePipe],
    templateUrl: './drone-report-item.component.html',
})
export class DroneReportItemComponent {
    @Input({required: true}) report!: DroneReport;

    @Output() download = new EventEmitter<DroneReport>();
    @Output() retry = new EventEmitter<DroneReport>();
    @Output() remove = new EventEmitter<DroneReport>();
    
    protected readonly reports = inject(DroneReportService);
}